import * as yup from 'yup'
export default yup.object().shape({
  country : yup.string().required(),
})

export type FormValues = {
  country : string,
}
